module.exports = __webpack_public_path__ + "static/media/logo.3ee73df4.png";